var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 177,
    viewBox: "0 0 189 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 177
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(7.839 -15.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M117.338,1.154c-7.387,2.131-14,7.007-18.935,12.888-7.8,9.292-8.644,22.186-13.516,33.046C77.56,63.419,61.827,74.661,45.141,81.141c-8.262,3.208-17,5.5-24.461,10.28C5.627,101.073-1.9,120.3.41,138.037c3.2,24.546,26.369,44.93,49.145,52,27.346,8.491,64.656-1.126,83.625-22.668,17.048-19.362,27.9-43.94,31.61-69.469,4.134-28.426,3-94.3-37.1-97.8a28.337,28.337,0,0,0-10.352,1.054Z",
    transform: "translate(34.041 -18.328) rotate(17)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(23.904 121.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M1993.28,499.157H1981.3V485.318h-13.839V473.331H1981.3V459.484h11.987v13.847h13.847v11.987h-13.847Zm-10.506-1.482h9.024V483.836h13.847v-9.024H1991.8V460.966h-9.024v13.846h-13.838v9.024h13.838Z",
    transform: "translate(-1967.457 -459.484)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(113.839 45.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M2140.72,331.533h-7.965v-9.2h-9.2v-7.965h9.2v-9.2h7.965v9.2h9.2v7.965h-9.2Zm-6.981-.985h6v-9.2h9.2v-6h-9.2v-9.2h-6v9.2h-9.2v6h9.2Z",
    transform: "translate(-2123.562 -305.172)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(28.623 19.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M2185.25,357.354h-5.739V351.09h-6.264v-5.739h6.264v-6.267h5.739v6.267h6.268v5.739h-6.268Zm-4.754-.985h3.77v-6.264h6.267v-3.77h-6.267v-6.267h-3.77v6.267h-6.264v3.77h6.264Z",
    transform: "translate(-2173.243 -339.084)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(17.56 50.665) rotate(-28.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M0,8.06,49.918,0,64.476,135.2s4.994,26.637-19.353,30.383-26.637-18.1-28.51-25.8S0,8.06,0,8.06Z",
    transform: "translate(8.663 18.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(19.954 45.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M31.448,133.076A17.831,17.831,0,0,1,12.086,116.92L.01,5.2A2.2,2.2,0,0,1,2,2.819l1.375-.127L33.144.009A2.187,2.187,0,0,1,35.528,2L46.751,105.86l.852,7.854a17.831,17.831,0,0,1-16.155,19.362Z",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M31.448,130.384a17.831,17.831,0,0,1-19.361-16.156L.01,2.511A2.2,2.2,0,0,1,2,.127L3.372,0c1.659,18.263,10.9,100.612,43.379,103.168l.852,7.854A17.831,17.831,0,0,1,31.448,130.384Z",
    transform: "translate(0 2.692)",
    fill: "#cf3030",
    opacity: 0.49
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(8.657 16.631)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M45.187.258H45.18l-6,.655-3.013.316h-.008l-1.182.134-2.717.3-2.647.281L26.6,2.271l-6.582.711-3,.324H17l-5.623.605.211,1.717.331,2.731,1.844-.2,2-.218,1.788-.19,3.012-.331,6.574-.7,3.016-.32h.007l2.872-.31,1.513-.169,1.993-.211.176-.021,3.013-.324h.007l6-.648h.006Zm-.007,0-6,.655-3.013.316h-.008l-1.182.134-2.717.3c-.577,1.154-1.049,1.97-1.478,2.1a8.769,8.769,0,0,1-.929.141c-.7.092-1.753.2-3.02.331-1.858.19-4.187.4-6.588.626q-1.51.138-3.02.268c-2.02.19-3.984.359-5.638.506l.331,2.731,1.844-.2,2-.218,1.788-.19,3.012-.331,6.574-.7L30.153,6.4h.007l2.872-.31,1.513-.169,1.993-.211.176-.021,3.013-.324h.007l6-.648Zm22.5,140.81L53.865,13.309l-.4-3.7v0l-.542-5.018-.007-.049A5.077,5.077,0,0,0,48.207.012a5.225,5.225,0,0,0-.88.014l-2.14.232H45.18l-6,.655-3.013.316h-.008l-1.182.134-2.717.3-2.647.281L26.6,2.271l-6.582.711-3,.324H17l-5.623.605-3.02.331L5.218,4.58l-.683.077A5.008,5.008,0,0,0,1.828,5.8a5.183,5.183,0,0,0-.7.718A5.093,5.093,0,0,0,0,9.965a1.261,1.261,0,0,0,.028.289l.429,4.005L14.787,146.777a26.6,26.6,0,1,0,52.894-5.706Zm-9.213,16.717A22.11,22.11,0,0,1,19.25,146.3L4.939,13.921l-.45-4.153a.473.473,0,0,1,.036-.253.494.494,0,0,1,.091-.183.574.574,0,0,1,.408-.225L8.91,8.691l3.012-.331,1.844-.2,2-.218,1.788-.19,3.012-.331,6.574-.7L30.153,6.4h.007l2.872-.31,1.513-.169,1.993-.211.176-.021,3.013-.324h.007l6-.648h.006l2.07-.225a.2.2,0,0,1,.064-.007.594.594,0,0,1,.591.528l.007.063.64,5.9v.008l.43,3.969,13.683,126.6a21.968,21.968,0,0,1-4.763,16.233ZM45.187.258H45.18l-6,.655-3.013.316h-.008l-1.182.134-2.717.3-2.647.281L26.6,2.271l-6.582.711-3,.324H17l-5.623.605.211,1.717.331,2.731,1.844-.2,2-.218,1.788-.19,3.012-.331,6.574-.7,3.016-.32h.007l2.872-.31,1.513-.169,1.993-.211.176-.021,3.013-.324h.007l6-.648h.006Z",
    fill: "#beedfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(0 1.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M66.113,21.525a1.122,1.122,0,0,1-.322.077l-4.1.471-.387.046-2.873.332-6.488.748-3.26.378L41.6,24.4l-3.26.378-7.1.821-3.26.37-6.084.709-3.26.37-4.785.554-2.4.277-2.477.286-.783.092-4.309.5a1.557,1.557,0,0,1-1.733-1.373L.978,17.243.01,8.891A1.561,1.561,0,0,1,.852,7.327a1.368,1.368,0,0,1,.539-.169L5.3,6.706l3.26-.378,4.173-.48,2.953-.341,3.26-.378,6.084-.7,3.26-.379,7.1-.821,3.26-.37,7.077-.82,3.26-.378L55.472.912l3.26-.378L63.3.008a1.675,1.675,0,0,1,.534.033,1.532,1.532,0,0,1,.61.3,1.524,1.524,0,0,1,.589,1.05l1.153,9.966.979,8.513a1.547,1.547,0,0,1-1.052,1.655Z",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    transform: "translate(5.297 0.534)",
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M6.155,21.547l-2.477.286-.783.092L1.348,10.4.244,2.193l-.036-.3L0,.378,3.26,0l.162,1.186L3.576,2.34l1.041,7.769L5.584,17.3Z",
    transform: "translate(0 5.794)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M6.211,21.546l-3.26.37L2.482,18.5,0,.378,3.26,0,5.751,18.158Z",
    transform: "translate(10.385 4.594)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M6.211,21.546l-3.26.37L2.5,18.609,0,.378,3.26,0l2.5,18.271Z",
    transform: "translate(19.729 3.515)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M6.211,21.538l-3.259.378-.443-3.235L0,.37,3.26,0,5.768,18.279Z",
    transform: "translate(30.09 2.324)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M6.219,21.538l-3.26.378L1.209,9.163,0,.378,3.26,0l.812,5.913Z",
    transform: "translate(40.427 1.126)",
    fill: "#cf3030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M6.219,21.538l-3.26.378L.2,1.806,0,.378,3.26,0l.118.879Z",
    transform: "translate(50.175)",
    fill: "#cf3030"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523",
    transform: "translate(0.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M63.643,1.528c.075.677-1.507,1.485-4.314,2.333-5.44,1.646-15.518,3.439-27.115,4.7C19.955,9.88,9.235,10.251,3.8,9.683,1.431,9.433.068,9.008,0,8.411-.214,6.426,13.86,3.282,31.429,1.382S63.429-.449,63.643,1.528Z",
    fill: "#a31919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M63.643,1.528c.075.677-1.507,1.485-4.314,2.333C32.576,3.944,13.807,7.293,3.8,9.683,1.431,9.433.068,9.008,0,8.411-.214,6.426,13.86,3.282,31.429,1.382S63.429-.449,63.643,1.528Z",
    fill: "#a31919",
    opacity: 0.38
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportMedical);
export default __webpack_public_path__ + "static/media/transport-medical.0893de887e3366047e3450d8ddaada9d.svg";
export { ForwardRef as ReactComponent };